import Accordion from './Accordion';
import AccordionItem from './item';
import AccordionHeader from './header';
import AccordionBody from './body';
export { Accordion, AccordionItem, AccordionHeader, AccordionBody };
//# sourceMappingURL=index.js.map